import React, {useEffect, useState} from 'react';
import '../../scss/create_new_user.scss';
import Dropdown from '../Reusables/Dropdown';
import getProfile from '../actions/Profile';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import ProfileHeader from '../layout/ProfileHeader';
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList, parseUserName, parseUserRole } from '../../store/Actions';
import { useNavigate, useParams } from "react-router-dom";
import DeleteUser from '../popups/DeleteUser';
import ResetPassword from '../popups/ResetPassword';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import { useSelector } from 'react-redux';
import eyeIcon from '../../images/login/eyeicon.png';
import edit from '../../images/common/edit-blue.png';
import Snackbars from '../Reusables/Snackbar';
import Spinner from '../Reusables/Spinner';
import { trim } from '../Reusables/Function';

function CreateNewUser(props) {
    const {id} = useParams();
    const countryCodes = require('country-codes-list');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accessToken =  Cookies.get('access_token');
    const [pageType, setPageType] = useState(null);
    const [salutationLabel, setSalutationLabel] = useState("");
    const [callingCodeLabel, setCallingCodeLabel] = useState("+1");
    const [callingCodes, setCallingCodes] = useState(null);
    const [callingCodesDropdown, setCallingCodesDropdown] = useState(null);
    const [roles, setRoles] = useState(null);
    const[notificationGroup1CheckedState, setNotificationGroup1CheckedState] = useState(null);
    const[notificationGroup2CheckedState, setNotificationGroup2CheckedState] = useState(null);
    const [notificationGroup1Items, setNotificationGroup1Items] = useState(null);
    const [notificationGroup2Items, setNotificationGroup2Items] = useState(null);
    const [selectedGroup1Notifications, setSelectedGroup1Notifications] = useState([]);
    const [selectedGroup2Notifications, setSelectedGroup2Notifications] = useState([]);
    const[checkedState, setCheckedState] = useState(null);
    const countryCallingCodeObject = countryCodes.customList('countryCode', '+{countryCallingCode}');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordMismatch, setPasswordMismatch] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [editCliked, setEditClicked] = useState(false);
    const [showDeleteUser, setShowDeleteUser] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [isDeleteClicked, setDeleteClicked] = useState(false);
    const [isSuspendClicked, setSuspendClicked] = useState(false);
    const loggedInUserId = useSelector((state) => state.userId);
    const [errormsg, setErrorMessage] = useState('');
    const [errorreg, setErrorMessageReg] = useState('');
    const [errormessage, setErrorMsg] = useState('');
    const [enable, setEnable] = useState(true);
    const [enableOverviewSave, setEnableOverviewSave] = useState(true);
    const [open, setOpen] = useState(null)
    const [openreg, setOpenReg] = useState(null)
    const [openmsg, setOpenmsg] = useState(null)
    const [disabling, setDisable] = useState(false)
    const [isLoading, setLoading] = useState(true);
    const userId = useSelector((state) => state.userId);
    const [isAdminClicked, setAdminClicked] = useState(false);
    const [roleId, setRoleId] = useState(null);
    const [values, setValues] = useState({
        salutation: null,
        firstName: null,
        lastName: null,
        newPassword: null,
        confirmPassword: null,
        email: null,
        countryCode: "+1",
        phoneNumber: null,
        password: null,
        description: null,
        roles: null,
        notificationTypes: null
    });
    const salutationList = [
        {id: 1, name: "Mr"}, 
        {id: 2, name: "Mrs"}, 
        {id: 3, name: "Miss"}
    ];
    const breadcrumbsListNew = [
        { "name": "Home", "url": "" },
        { "name": "Users", "url": "users/list" },
        { "name": "New user", "url": "users/new" }
    ];

    const handleCloseDeleteUserPopup = () => setShowDeleteUser(false);
    const handleShowDeleteUserPopup = () => setShowDeleteUser(true);

    const handleCloseResetPasswordPopup = () => setShowResetPassword(false);
    const handleShowResetPasswordPopup = () => setShowResetPassword(true);

    useEffect(() => {
        window.scroll(0, 0);

        const callApi = (accesstoken) =>{
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                accessToken && getNotificationTypes(accesstoken);

                if(window.location.href.includes('new')) {
                    setPageType("new");
                    dispatch(parseBreadcrumbsList(breadcrumbsListNew));
                } else if(window.location.href.includes('edit')) {
                    setPageType("edit");
                    getUserDetails("edit", accesstoken);
                } else if(window.location.href.includes('view')) {
                    setPageType("view");
                    getUserDetails("view", accesstoken);
                    const path = window.location.href;
                    const pathSplit = path.split('/');
                    const id = parseInt(pathSplit[pathSplit.length - 2]);
                    if(userId === id) {
                        setDisable(true);
                    } 
                }

                getCountryCodeArray();
                accessToken && getRoles(accesstoken);
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [])

    const getUserDetails = (page, accesstoken) => {
        getProfile.GetUserDetails(`/api/users/info?userId=${id}`, accesstoken, (data) => {
            if(data.status == 200) {
                setLoading(false)
                setUserDetails(data.data.data)
                getParsedValues(data.data.data);
                if(page == "edit") {
                    const breadcrumbsListEdit = [
                        { "name": "Home", "url": "" },
                        { "name": "Users", "url": "users/list" },
                        { "name": data.data.data.lastName != null ? `${data.data.data.firstName} ${data.data.data.lastName}: Edit` : 
                        `${data.data.data.firstName}: Edit`, "url": `users/${id}/edit` }
                    ];
                    dispatch(parseBreadcrumbsList(breadcrumbsListEdit));
                } else if(page == "view") {
                    const breadcrumbsListView = [
                        { "name": "Home", "url": "" },
                        { "name": "Users", "url": "users/list" },
                        { "name": data.data.data.lastName != null ? `${data.data.data.firstName} ${data.data.data.lastName}` : 
                        `${data.data.data.firstName}`, "url": `users/${id}/view` }
                    ];
                    dispatch(parseBreadcrumbsList(breadcrumbsListView));
                }
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    const getParsedValues = (data) => {
        var rolesArray = [];
        var notificationArray = [];
        var notification1Array = [];
        var notification2Array = [];

        data.selectedRoles != null && data.selectedRoles.map((item) => {
            rolesArray.push(item.idRoles);
        })
        data.selectedNotificationTypes != null && data.selectedNotificationTypes.map((item) => {
            notificationArray.push(item.idNotificationType);
            if(item.groupId == 1) {
                notification1Array.push(item.idNotificationType);
            } else {
                notification2Array.push(item.idNotificationType);
            }
        })
        setValues({
            ...values,
            salutation: data.salutation,
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            countryCode: data.countryCode ? data.countryCode : "+1",
            phoneNumber: data.phoneNumber,
            description: data.description,
            roles: rolesArray,
            notificationTypes: notificationArray
        })
        setSalutationLabel(data.salutation);
        setRoleId(rolesArray)
        setSelectedGroup1Notifications(notification1Array);
        setSelectedGroup2Notifications(notification2Array);
        data.countryCode ? setCallingCodeLabel(data.countryCode && data.countryCode) : setCallingCodeLabel("+1");
    }

    useEffect(() => {
        const codesArray = [];
        callingCodes != null && callingCodes.map((code) => {
            const codeObject = {id: 0, name: ''}
            codeObject.id = 1;
            codeObject.name = code;
            codesArray.push(codeObject);
        })
        setCallingCodesDropdown(codesArray);
    }, callingCodes)

    const getCountryCodeArray = () => {
        const countryCallingCodeArray = [];
        Object.keys(countryCallingCodeObject).forEach((key) => {
            if(!countryCallingCodeArray.includes(countryCallingCodeObject[key])) {
                countryCallingCodeArray.push(countryCallingCodeObject[key].replace(/ /g, ''));
            }
        });
        setCallingCodes(countryCallingCodeArray.sort());
    }

    const getRoles = (accesstoken) => {
        getProfile.GetRole('/api/roles', accesstoken, (data) => {
            if(data.status == 200) {
                setLoading(false)
                setRoles(data.data.data);
                setCheckedState(new Array(data.data.data.length).fill(false))
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    const getNotificationTypes = (accesstoken) => {
        getProfile.GetRole('/api/users/notificationtypes', accesstoken, (data) => {
            if(data.status == 200) {
                setLoading(false)
                const group1Items = [];
                const group2Items = [];
                const response = data.data.data;
                response != null && response.length > 0 && response.map((item) => {
                    if(item.groupId == 1) {
                        group1Items.push(item);
                    } else {
                        group2Items.push(item);
                    }
                })
                setNotificationGroup1Items(group1Items);
                setNotificationGroup2Items(group2Items);
                setNotificationGroup1CheckedState(new Array(group1Items.length).fill(false));
                setNotificationGroup2CheckedState(new Array(group2Items.length).fill(false));
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    useEffect(() => {
        const selectedRoles = [];
        if(roles != null && pageType == "new") {
            setRoleId(2);
            for(let i=0; i < roles.length; i++) {
                if(roles[i].default == true) {
                    document.querySelector(`input[value='${roles[i].roleName}']`).checked = true;
                    selectedRoles.push(roles[i].idRoles);
                    break;
                }
            }

            setValues({
                ...values,
                roles: selectedRoles
            })
        }

        if(userDetails != null && roles != null) {  
            if(pageType == "edit" || pageType == "view-edit-user") {
                document.querySelector(`input[value='${userDetails.selectedRoles[0].roleName}']`).checked = true;
                setRoleId(userDetails.selectedRoles[0].idRoles)

                userDetails.selectedNotificationTypes != null && userDetails.selectedNotificationTypes.length > 0 && 
                    userDetails.selectedNotificationTypes.map(type => {
                        if(type.groupId == 1 && notificationGroup1Items != null && notificationGroup1CheckedState != null) {
                            for(let i=0; i<notificationGroup1Items.length; i++) {
                                if(type.name == notificationGroup1Items[i].name) {
                                    notificationGroup1CheckedState[i] = true;
                                }
                            }
                        } else if (type.groupId == 2 && notificationGroup2Items != null && notificationGroup2CheckedState != null) {
                            for(let i=0; i<notificationGroup2Items.length; i++) {
                                if(type.name == notificationGroup2Items[i].name) {
                                    notificationGroup2CheckedState[i] = true;
                                }
                            }
                        }
                        
                        setNotificationGroup1CheckedState(notificationGroup1CheckedState);
                        setNotificationGroup2CheckedState(notificationGroup2CheckedState);
                })
            }          
        }
    }, [roles, userDetails, pageType, notificationGroup1Items, notificationGroup2Items])

    useEffect(() => {
        if(roleId != null && roleId == 1) {
            setAdminClicked(true);
        } else {
            setAdminClicked(false);
        }
    }, [roleId])

    const handleSalutation = (value) => {
        setValues({
            ...values,
            salutation: value
        })
    }

    const handleFirstName = (value) => {
        setValues({
            ...values,
            firstName: value
        })
    }

    const handleLastName = (value) => {
        setValues({
            ...values,
            lastName: value
        })
    }

    const handleNewPassword = (value) => {
        setValues({
            ...values,
            newPassword: value
        })
    }

    const handleConfirmPassword = (value) => {
        setValues({
            ...values,
            confirmPassword: value
        })
    }

    const handleEmailId = (value) => {
        setValues({
            ...values,
            email: value
        })
    }

    const handleCallingCode = (value) => {
        setValues({
            ...values,
            countryCode: value
        })
    }

    const handlePhoneNumber = (value) => {
        setValues({
            ...values,
            phoneNumber: value
        })
    }

    const handleDescription = (value) => {
        setValues({
            ...values,
            description: value
        })
    }

    const handleRoles = (e, roleId) => {
        setRoleId(roleId)

        const selectedRoles = [];
        if(e.target.checked == true) {
            selectedRoles.push(roleId);
        }

        setValues({
            ...values,
            roles: selectedRoles
        })
    }

    const handleNotification = (position, type) => {
        var selectedItems = [];
        if(type == "Group1") {
            const updatednotificationGroup1CheckedState = notificationGroup1CheckedState.map((item, index) => {
                if(position == index) {
                    return !item;
                } else {
                    return item;
                }
            })
    
            setNotificationGroup1CheckedState(updatednotificationGroup1CheckedState);
    
            updatednotificationGroup1CheckedState.map((item, index) => {
                if(item) {
                    selectedItems.push(notificationGroup1Items[index].idNotificationType)
                }
            })

            setSelectedGroup1Notifications(selectedItems);
        } else {
            const updatednotificationGroup2CheckedState = notificationGroup2CheckedState.map((item, index) => {
                if(position == index) {
                    return !item;
                } else {
                    return item;
                }
            })
    
            setNotificationGroup2CheckedState(updatednotificationGroup2CheckedState);
    
            updatednotificationGroup2CheckedState.map((item, index) => {
                if(item) {
                    selectedItems.push(notificationGroup2Items[index].idNotificationType)
                }
            })
            setSelectedGroup2Notifications(selectedItems);
        }
    }

    useEffect(() => {
        console.log("[USER] Values ", values)
        setValues({
            ...values,
            notificationTypes: selectedGroup1Notifications.concat(selectedGroup2Notifications)
        })
    }, [selectedGroup1Notifications, selectedGroup2Notifications])

    const handleNewPasswordShow = () => {
        setShowNewPassword(!showNewPassword);
    }

    const handleConfirmPasswordShow = () => {
        setShowConfirmPassword(!showConfirmPassword)
    }

    const handleCreateUser = () => {
        if(values.newPassword != values.confirmPassword) {
            setPasswordMismatch(true);
            setErrorMessageReg('');
            setOpenReg(false);
            window.scroll(0, 0);
        } else {
            setEnable(false);
            setPasswordMismatch(false);
            callCreateUserApi();
        }
    }

    const handleEdituser = () => {
        setEnable(false);
        setEnableOverviewSave(false);
        const details = updateValues('edit');

        const callApi = (accesstoken) => {
            getProfile.EditUser('/api/users/edit/', accesstoken, details, (data) => {
                setEnable(true);
                setEnableOverviewSave(true);
                if(data.status == 200) {
                    setLoading(true)
                    if(pageType == "edit") {
                        if(id == loggedInUserId) {
                            if(values.roles[0] == 1) {
                                navigate('/users/list');
                            } else {
                                navigate('/profile')
                            }
                        } else {
                            navigate('/users/list');
                        }
                    } else if(pageType == "view-edit-user") {
                        if(id == loggedInUserId) {
                            if(values.roles[0] == 1) {
                                getViewDetails(accesstoken);
                            } else {
                                navigate('/profile')
                            }
                        } else {
                            getViewDetails(accesstoken);
                        }
                    }

                    // Updating the logged in username in the Profile
                    if(id == loggedInUserId) {
                        const name = values.firstName +' '+values.lastName;
                        dispatch(parseUserName(name));
                        dispatch(parseUserRole(values.roles[0]));
                    }
                }
                else if(data.status == 400 || data.status == 404) {
                    setLoading(false)
                    setErrorMessage(data.data.message);
                    setOpen(true)
                } else if(data.status == 401) {
                    navigate("/login")
                }           
            })
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const getViewDetails = (accesstoken) => {
        getProfile.GetUserDetails(`/api/users/info?userId=${id}`, accesstoken, (data) => {
            if (data.status == 200) {
                setLoading(false)
                setEditClicked(!editCliked);
                setPageType("view");
                setUserDetails(data.data.data);
                navigate(`/users/${id}/view`);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const callCreateUserApi = () => {
        const details = updateValues('new')

        const callApi = (accesstoken) => {
            getProfile.CreateNewUser('/api/users/register', accesstoken, details, (data) => {
                setEnable(true);
                if(data.status == 200) {
                    setLoading(true)
                    navigate('/users/list');
                    setErrorMessageReg('');
                    setOpenReg(false);
                }
                else if(data.status == 400 || data.status == 404) {
                    setLoading(false)
                    setErrorMessageReg(data.data.message);
                    setOpenReg(true)
                } else if(data.status == 401) {
                    navigate("/login")
                }
            })
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const updateValues = (type) => {
        const details = {
            Salutation: values.salutation,
            FirstName: trim(values.firstName),
            LastName: trim(values.lastName),
            Email: trim(values.email),
            CountryCode: values.countryCode,
            PhoneNumber: trim(values.phoneNumber),
            Description: trim(values.description),
            Roles: values.roles,
            NotificationTypes: values.roles[0] == 1 ? values.notificationTypes : []
        }

        if(type == 'new') {
            details.Password = trim(values.confirmPassword)
        }else if(type == 'edit') {
            details.UserId = id;
        }
        return details;
    }

    const handleEdit = () => {
        setEditClicked(!editCliked);
        setPageType("view-edit-user");
    }

    const handleSave = () => {
        handleEdituser();
    }

    const handleDeleteUser = () => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                if(isDeleteClicked) {
                    getProfile.DeleteUser(`/api/users/delete?userId=${id}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            if(userId == id) {
                                navigate('/login')
                            } else {
                                navigate('/users/list')
                            }
                            handleCloseDeleteUserPopup();
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                } else if(isSuspendClicked) {
                    getProfile.SuspendUser(`/api/users/suspend?UserId=${id}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            if(userId == id) {
                                navigate('/login')
                            } else {
                                navigate('/users/list')
                            }
                            handleCloseDeleteUserPopup();
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const handleDelete = () => {
        setDeleteClicked(true);
        setSuspendClicked(false);
        handleShowDeleteUserPopup();
    }

    const handleReset = () => {
        handleShowResetPasswordPopup();
        setErrorMsg('')
        setOpenmsg(false)
    }

    const handleResetPassword = (details) => {
        details.UserId = id

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                if((details.NewPassword != null && details.NewPassword != "") || (details.ConfirmPassword != null && details.ConfirmPassword != "")) {
                    getProfile.ResetPassword('/api/users/reset/password', accesstoken, details, (data) => {
                        if (data.status == 200) {
                            handleCloseResetPasswordPopup();
                            setErrorMsg('');
                            setOpenmsg(false)
                        }
                        else if(data.status == 400 || data.status == 404) {
                            handleShowResetPasswordPopup();
                            setErrorMsg(data.data.message)
                            setOpenmsg(true)
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const handleSuspend = () => {
        handleShowDeleteUserPopup();
        setDeleteClicked(false);
        setSuspendClicked(true);
    }

    return(
        <>
            {console.log("[USER] User ", values)}
            <div className="create-user-container">
                <Header />

                <div className="row create-user-sub-container">
                    <Sidebar />

                    <div className='col-10 create-user-body-container'>
                        <div className='sub-header'>
                            <Breadcrumbs/>
                        </div>
                        {isLoading ? 
                            (<Spinner/>) : ( <>

                        <ProfileHeader/>
                        <div className='create-new-user-container'>
                            <div className='header-container'>
                                {pageType == "new" && <div className='create-new-header'>Create New User</div>}
                                {pageType == "edit" && <div className='create-new-header'>Edit User</div>}
                                {(pageType == "view" || pageType== "view-edit-user") && <div className='create-new-header'>User Info</div>}
                                {(pageType == 'view' || pageType== "view-edit-user") && 
                                    <div className='edit-container'>
                                        <div className='edit'>{editCliked ? <button disabled={enableOverviewSave ? false : true} className={enableOverviewSave ? 'save-btn enable' : 'save-btn disable'} onClick={handleSave}>Save</button> : 
                                        <img src={edit} alt="Edit"  onClick={handleEdit}/>}</div>
                                    </div>}   
                            </div>
                            <div className='sub-section1'>
                                <div className='first-name-field'>
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ?<div className='label label-color required'>First Name</div> : <div className='label'>First Name</div>}
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? 
                                    (<>
                                        <Dropdown label={salutationLabel} selectedItem={(name, id) => handleSalutation(name)}
                                            handleLabel={(value) => setSalutationLabel(value)} list={salutationList} enable={true}/>
                                        <input className='input-field' type="text" value={values.firstName} onChange={(e) => handleFirstName(e.target.value)}
                                        maxLength={45}/>
                                    </>) : 
                                    (<div className='overview-field'>{values.firstName}</div>)}
                                </div>
                                <div className='last-name-field'>
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ?<div className='label label-color'>Last Name</div> : <div className='label'>Last Name</div>}
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? 
                                    (<input className='input-field' type="text" value={values.lastName} onChange={(e) => handleLastName(e.target.value)}
                                    maxLength={45}/>) : 
                                    (<div className='overview-field'>{values.lastName}</div>)}
                                </div>
                            </div>
                            {pageType == 'new' && 
                                <div className='sub-section1-password'>
                                    <div className='new-password-field'>
                                        <div className='label label-color'>New Password</div>
                                        <div className='password-input-field'>
                                            <input className='input-field' type={showNewPassword ? "text" : "password"} onChange={(e) => handleNewPassword(e.target.value)}
                                            maxLength={20}/>
                                            <img src={eyeIcon} alt="eye-icon" onClick={handleNewPasswordShow}></img>
                                        </div>
                                    </div>
                                    <div className='confirm-password-field'>
                                        <div className='label label-color'>Confirm Password</div>
                                        <div className='password-input-field'>
                                            <input className='input-field' type={showConfirmPassword ? "text" : "password"} onChange={(e) => handleConfirmPassword(e.target.value)}
                                            maxLength={20}/>
                                            <img src={eyeIcon} alt="eye-icon" onClick={handleConfirmPasswordShow}></img>
                                        </div> 
                                    </div>
                                </div>}
                            <div className='sub-section2'>
                                <div className='email-field'>
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ?<div className='label required label-color'>Email Id</div> : <div className='label'>Email Id</div>}
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? 
                                    (<input className='input-field' type="email" name="email" value={values.email} onChange={(e) => handleEmailId(e.target.value)}
                                    maxLength={45}/>) : 
                                    (<div className='overview-field'>{values.email}</div>)}
                                </div>
                                <div className='phone-number-field'>
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ?<div className='label required label-color'>Phone Number</div> : <div className='label'>Phone Number</div>}
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? 
                                    (<>
                                        <Dropdown label={callingCodeLabel} selectedItem={(name, id) => handleCallingCode(name)}
                                            handleLabel={(value) => setCallingCodeLabel(value)} list={callingCodesDropdown} enable={true}/>
                                        <input className='input-field' type="text" value={values.phoneNumber} onChange={(e) => handlePhoneNumber(e.target.value)}
                                        maxLength={15}/>
                                    </>) : 
                                    (<div className='overview-field'>{values.phoneNumber}</div>)}
                                </div>
                            </div>
                            <div className='sub-section3'>
                                <div className='description-field'>
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? <div className='label label-color'>Description</div> : <div className='label'>Description</div>}
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? 
                                    (<textarea maxLength={1000} value={values.description} className="about" rows="3" onInput={(e) => handleDescription(e.target.value)}></textarea>) :
                                    (<div className='overview-field'>{values.description}</div>)}
                                </div>
                            </div>
                            <div className='sub-section4'>
                                <div className='available-roles'>
                                    {pageType == "view" ? <div className='label-header'>Roles</div> :
                                    <div className='label-header'>Available Roles</div>}
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? 
                                    <div className='role-section'>
                                        {(roles != null && roles.length > 0) && roles.map((item, index) => {
                                            return(
                                                <div className='radio-button'>
                                                    <input type="radio" id={item.roleName} name='radio' value={item.roleName} onChange={(e) => handleRoles(e, item.idRoles)}/>
                                                    <label for={item.roleName}>{item.roleName}</label>
                                                </div>
                                            )
                                        })}
                                    </div> : 
                                    <div className='overview-roles-field'>
                                        {(userDetails != null && userDetails.selectedRoles != null) && userDetails.selectedRoles.map((item) => {
                                            return (<div className='overview-field'>{item.roleName}</div>)
                                        })}
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className={`sub-section5 ${(!isAdminClicked && (pageType == "edit" || pageType == "new" || pageType== "view-edit-user" || (pageType == "view" && roleId != 1))) ? 'sub-section5-no-border' : ''}`}>
                                <div className='notification-preferences'>
                                    {((pageType == "view" && roleId == 1) || isAdminClicked) && <div className='label-header'>Notification Preferences</div>}
                                    {(pageType == "edit" || pageType == "new" || pageType== "view-edit-user") ? 
                                    isAdminClicked && 
                                    <>
                                        <div className='checkbox notification-checkbox group1'>
                                            {(notificationGroup1Items != null && notificationGroup1Items.length > 0) && notificationGroup1Items.map((item, index) => {
                                                return(
                                                    <label>
                                                        {notificationGroup1CheckedState != null && <input type="checkbox" onChange={() => handleNotification(index, "Group1")} checked={notificationGroup1CheckedState[index]}/>}
                                                        <span class="checkmark notification-checkmark"></span>
                                                        <span className="label">{item.name}</span> 
                                                    </label>
                                                )
                                            })}
                                        </div>
                                        <div className='checkbox notification-checkbox group2'>
                                            {(notificationGroup2Items != null && notificationGroup2Items.length > 0) && notificationGroup2Items.map((item, index) => {
                                                return(
                                                    <label>
                                                        {notificationGroup2CheckedState != null && <input type="checkbox" onChange={() => handleNotification(index, "Group2")} checked={notificationGroup2CheckedState[index]}/>}
                                                        <span class="checkmark notification-checkmark"></span>
                                                        <span className="label">{item.name}</span> 
                                                    </label>
                                                )
                                            })}
                                        </div>
                                    </>
                                     : 
                                    <>
                                        <div className='overview-notification-field overview-notification-group1'>
                                            {(userDetails != null && userDetails.selectedNotificationTypes != null) && userDetails.selectedNotificationTypes.map((item) => {
                                                return (item.groupId == 1 && <div className='overview-field'>{item.name}</div>)
                                            })}
                                        </div>
                                        <div className='overview-notification-field overview-notification-group2'>
                                            {(userDetails != null && userDetails.selectedNotificationTypes != null) && userDetails.selectedNotificationTypes.map((item) => {
                                                return (item.groupId == 2 && <div className='overview-field'>{item.name}</div>)
                                            })}
                                        </div>
                                    </>
                                    }
                                </div>
                            </div>
                            {(pageType == 'view') && 
                                <div className='edit-containers'>
                                    <div className='view-sub-headers'>
                                        <button className="delete"  onClick={handleDelete}>Delete User</button>
                                        {/* <button className="delete"  onClick={handleSuspend}>Suspend User</button> */}
                                        <button className="delete"  onClick={handleReset}>Reset Password</button>
                                    </div>
                                </div>
                            }  
                            {(pageType != "view" && pageType != "view-edit-user") && 
                            <div className='save-button'>
                                {pageType == 'new' ?
                                    (<button disabled={enable ? false : true} className={enable ? 'add-button enable' : 'add-button disable'} onClick={handleCreateUser}>Save</button>)
                                    :
                                    (<button disabled={enable ? false : true} className={enable ? 'edit-button enable' : 'edit-button disable'} onClick={handleEdituser}>Save</button>)
                                }
                            </div>}
                        </div></>)}
                    </div>
                </div>

                {/* Showing delete popup */}
                <DeleteUser show={showDeleteUser} handleClose={handleCloseDeleteUserPopup} deleteApiCall={handleDeleteUser}
                type={isDeleteClicked ? "delete": "suspend"} enable={true}/>

                {/* Showing reset password popup */}
                <ResetPassword  errormessage ={null} show={showResetPassword} handleClose={handleCloseResetPasswordPopup} 
                resetPasswordApiCall={(details) => handleResetPassword(details)}/>
                <Snackbars error={errormessage} open={openmsg} setOpen={setOpenmsg}/>
                {pageType == "edit" && <Snackbars error={errormsg} open={open} setOpen={setOpen}/>}
                {pageType == "new" && <Snackbars error={errorreg} open={openreg} setOpen={setOpenReg}/>}
                {passwordMismatch && <Snackbars error={"Password Mismatch"} open={passwordMismatch} setOpen={setPasswordMismatch}/>}
                {pageType == "view-edit-user" && <Snackbars error={errormsg} open={open} setOpen={setOpen}/>}
                <Footer />
            </div>
        </>
    )
}

export default CreateNewUser;